import { DeviceTypesEnum } from "../../enums/DeviceTypesEnum";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
import { RulesEngineRuleTypeEnum } from "../../enums/RulesEngineTypeEnum";

export function parseObjectEquatableKey(
    equatableKey: string
): {
    objectType: eLynxObjectTypeEnum | undefined;
    id: number | undefined;
    deviceType: DeviceTypesEnum | undefined;
    ruleType: RulesEngineRuleTypeEnum | undefined;
} {

    const components: string[] = equatableKey.split(":");
    const objectType = components.length > 0 && components[0].length > 0 ? Number(components[0]) as eLynxObjectTypeEnum : undefined;

    return {
        objectType,
        id: components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined,
        deviceType: objectType === eLynxObjectTypeEnum.Tank && components.length > 2 && components[2].length > 0 ? Number(components[2]) as DeviceTypesEnum : undefined,
        ruleType: objectType === eLynxObjectTypeEnum.RulesEngineRuleInstance && components.length > 2 && components[2].length > 0 ? Number(components[2]) as RulesEngineRuleTypeEnum : undefined
    };
}
